import { isValidPositiveValue } from '@buildersbank/validations';
import { FormValidator } from '~/modules';

export const validationSchema = FormValidator.object().shape({
  creditSimulationValue: FormValidator.string()
    .required('Valor incorreto')
    .test('creditSimulationValue', 'Valor incorreto', isValidPositiveValue),
});

export type CreditSimulationValueFormValues = Record<
  'creditSimulationValue',
  string
>;

export const initialValues: CreditSimulationValueFormValues = {
  creditSimulationValue: '',
};
